/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ standard: NonNullable<unknown>, high: NonNullable<unknown> }} Landing_Guide_S6_BodyInputs */

const en_landing_guide_s6_body = /** @type {(inputs: Landing_Guide_S6_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This is an independent workspace for Ideogram 4.5, not the official Ideogram site. Sign up, write a prompt or upload an image, and check the credit cost next to the button before you submit: the standard mode uses ${i?.standard} credits per image and High mode uses ${i?.high}. Failed generations are refunded automatically, every result is saved to My images, and the "Keep editing this" button starts the next pass from the exact pixels you just approved.`)
};

const zh_landing_guide_s6_body = /** @type {(inputs: Landing_Guide_S6_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`这是一个独立的 Ideogram 4.5 工作台，并非 Ideogram 官方网站。注册后写下提示词或上传图片，提交前先看按钮旁的积分报价：Ideogram 4.5 每张 ${i?.standard} 积分，Ideogram 4.5 High 每张 ${i?.high} 积分。生成失败会自动退回积分，每张结果都保存在“我的图片”里，点击“继续编辑这张”即可从你刚确认的像素开始下一轮修改。`)
};

/**
* | output |
* | --- |
* | "This is an independent workspace for Ideogram 4.5, not the official Ideogram site. Sign up, write a prompt or upload an image, and check the credit cost next..." |
*
* @param {Landing_Guide_S6_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s6_body = /** @type {((inputs: Landing_Guide_S6_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S6_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s6_body(inputs)
	return zh_landing_guide_s6_body(inputs)
});
export { landing_guide_s6_body as "landing.guide.s6_body" }